import classNames from 'classnames';
import { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

import {
  Box,
  BoxProps,
  hoverStyle,
  selectedStyle,
} from '@sorare/core/src/atoms/ui/Box';
import { getTextColorFomBackgroundColor } from '@sorare/core/src/lib/colors';

import lightningBg from './assets/lightning-bg.svg';

const Wrapper = styled(Box)`
  align-items: center;
  justify-content: center;
  padding: 0;
  overflow: hidden;
  background: var(--c-neutral-200);

  &.withLightning {
    background:
      center / cover url(${lightningBg}),
      var(--c-neutral-200);
  }

  &.selectable:hover,
  &.selectable:focus {
    cursor: pointer;
    ${hoverStyle}
  }
  &.selected {
    ${selectedStyle}
  }
  &.color {
    background:
      center / cover url(${lightningBg}),
      linear-gradient(to right, var(--lightning-color), var(--lightning-color));
  }
  &.locked {
    border: 1px solid var(--c-neutral-100);
  }
`;

type Props = {
  children: ReactNode;
  withLightning?: boolean;
  lightningColor?: string | null;
} & BoxProps;

export const GameWrapper = ({
  children,
  withLightning,
  lightningColor,
  className,
  ...rest
}: Props) => {
  const color = lightningColor
    ? getTextColorFomBackgroundColor(lightningColor)
    : 'var(--c-neutral-1000)';

  return (
    <Wrapper
      {...rest}
      className={classNames(className, {
        withLightning,
        color: !!lightningColor,
      })}
      style={
        lightningColor
          ? ({
              '--lightning-color': lightningColor,
              color,
            } as CSSProperties)
          : undefined
      }
    >
      {children}
    </Wrapper>
  );
};
